import momentEU from 'moment/locale/eu'
import login from './en-US/login'

const components = {
  momentName: 'eu',
  momentLocale: momentEU
}

export default {
  'message': '-',

  ...components,
  ...login
}



// WEBPACK FOOTER //
// ./src/locales/lang/en-US.js